.itemFixedLabel {
  width: 14vw;
  vertical-align: top;

  &::after {
    content: none !important;
  }
}